// extracted by mini-css-extract-plugin
export default {"container":"Authenticator_container__C2F1K"};